import React from 'react'
import ContentVehicleMultiCardListing from '../../../components/ContentVehicleMultiCardListing/index'
import ContentSectionHeader from '../../../components/ContentSectionHeader/index'
import { carCardDetails } from '../../../setup/stubs'

const RecentlyViewedVehiclesWidget = () => {
  carCardDetails.map((car) => {
    car.offer = false
    car.outlined = false
    return car
  })

  return (
    <div>
      <ContentSectionHeader
        title="Your recently viewed vehicles"
        fg="rgba(154,163,179,0.65)"
      />
      <ContentVehicleMultiCardListing vehicles={carCardDetails} max={4} loop />
    </div>
  )
}

export default RecentlyViewedVehiclesWidget
